// @flow
import * as React from 'react';
import { getAuctioneerDirectoryUrl, getAuctionResultsUrl } from '../../../utils/urls';
import { FormattedMessage } from 'react-intl';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import styles from './LACrown.module.scss';

type Props = {|
    baseUrl: string,
|};

const LACrown = (props: Props) => {
    const { baseUrl } = props;

    return (
        <div className={styles.crown}>
            <div className={styles['crown-inner']}>
                <Link route secondary to={getAuctioneerDirectoryUrl()}>
                    <FormattedMessage id="directory" />
                </Link>
                <Link route secondary to={getAuctionResultsUrl()}>
                    <FormattedMessage id="price_results" />
                </Link>
                <Link secondary target="_blank" to={`${baseUrl}/news/`}>
                    <FormattedMessage id="news" />
                </Link>
                <Link rel="noopener" secondary target="_blank" to="https://help.liveauctioneers.com/">
                    <FormattedMessage id="help" />
                </Link>
                <Link route secondary to="/consignments">
                    <FormattedMessage id="consign" />
                </Link>
            </div>
        </div>
    );
};

export default React.memo<Props>(LACrown);
